import { render, staticRenderFns } from "./ListSelectedGuardias.vue?vue&type=template&id=32be8222&scoped=true&"
import script from "./ListSelectedGuardias.vue?vue&type=script&lang=js&"
export * from "./ListSelectedGuardias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32be8222",
  null
  
)

export default component.exports